import { useRef, useState } from "react";
import audio from "../../assets/sampleaudio.wav";
import { motion } from "framer-motion";
import audioanimation from "../../assets/audioanimation.png";
import Title from "../typography/Title";

const AudioPlayer = () => {
  const audioRef = useRef(new Audio(audio));
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  return (
    <div className="bg-pattern relative flex h-full min-h-[20rem] w-full flex-col items-center justify-center gap-10 bg-purple-900 px-5">
      <Title>Listen to Eric</Title>
      <div className="flex h-24 items-center justify-center rounded-2xl bg-gray-200">
        <div
          className="absolute z-10 h-12 w-12 cursor-pointer rounded-full bg-amber-800 opacity-100"
          onClick={() => {
            setIsAudioPlaying((prev) => {
              if (!prev) {
                audioRef.current.play();
              } else {
                audioRef.current.pause();
              }
              console.log("setting is audion playing", prev);
              return !prev;
            });
          }}
        >
          {!isAudioPlaying ? (
            <div className="absolute left-4 top-3 h-0 w-0 scale-90 border-b-[12px] border-l-[20px] border-t-[12px] border-b-transparent border-l-gray-100 border-t-transparent hover:scale-105" />
          ) : (
            // Pause Icon
            <div className="absolute left-3.5 top-3 flex gap-2">
              <div className="h-6 w-1.5 bg-white" />
              <div className="h-6 w-1.5 bg-white" />
            </div>
          )}
        </div>
        <motion.img
          src={audioanimation}
          className="h-auto w-full object-cover"
          key={String(isAudioPlaying)}
          animate={
            isAudioPlaying
              ? {
                  scaleY: [1, 1.5, 1],
                  y: [0, 1, 0],
                }
              : { scaleY: 1, y: 0 }
          }
          transition={
            isAudioPlaying
              ? {
                  duration: 0.8,
                  repeat: Infinity,
                  ease: "easeInOut",
                }
              : {}
          }
        />
      </div>
    </div>
  );
};

export default AudioPlayer;
